export default function TrustStrip() {
  const countries = [
    { flag: "🇺🇸", name: "United States" },
    { flag: "🇬🇧", name: "United Kingdom" },
    { flag: "🇨🇦", name: "Canada" },
    { flag: "🇦🇺", name: "Australia" },
  ];

  const badges = [
    { icon: "ri-shield-check-line", text: "Updated Weekly Spreadsheet Data" },
    { icon: "ri-user-star-line", text: "Verified Shopping Agent Comparisons" },
    { icon: "ri-book-read-line", text: "Beginner-Friendly Guides" },
  ];

  return (
    <section className="w-full bg-background-100 border-y border-background-200/70 py-5">
      <div className="w-full px-6 md:px-10 max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-1.5">
              <div className="w-8 h-8 rounded-lg overflow-hidden bg-background-200 flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Minimalist%20illustration%20of%20a%20small%20world%20globe%20icon%20with%20soft%20warm%20lighting%2C%20clean%20flat%20design%2C%20neutral%20beige%20background%2C%20no%20text&width=64&height=64&seq=trust-globe-jun27&orientation=squarish"
                  alt="Global buyers"
                  className="w-full h-full object-cover"
                />
              </div>
              <p className="text-sm text-foreground-600 font-medium whitespace-nowrap">
                Trusted by global buyers in:
              </p>
            </div>
            <div className="flex items-center gap-4 flex-wrap">
              {countries.map((c) => (
                <span key={c.name} className="text-sm text-foreground-700 font-medium whitespace-nowrap">
                  {c.flag} {c.name}
                </span>
              ))}
            </div>
          </div>

          <div className="hidden lg:flex items-center gap-5">
            {badges.map((b) => (
              <span key={b.text} className="flex items-center gap-1.5 text-xs text-foreground-500 whitespace-nowrap">
                <i className={`${b.icon} text-secondary-500 text-sm w-4 h-4 flex items-center justify-center`}></i>
                {b.text}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}